import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Wrapper } from "../base/Wrapper";
import TitleBar from "../TitleBar";
import { Avatar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { getCurrentUserInfo } from "../../auth/getCurrentUserInfo";
import { getAllActivities } from "../../auth/getAllActivities";
import { useRecoilState } from "recoil";
import { allActivitiesState } from "../../lib/recoil";
import Skeleton from "@material-ui/lab/Skeleton";
import Typography from "@material-ui/core/Typography";
import MuiAccordion from "@material-ui/core/Accordion";
import {
  AccordionDetails,
  AccordionSummary,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
} from "@material-ui/core";
import { MdExpandMore, MdTimer } from "react-icons/md";
import { BiRun } from "react-icons/bi";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  accordion: {
    marginTop: theme.spacing(3),
  },
  accordionBar: {
    display: "flex",
    alignItems: "center",
  },
  avatarbg: {
    backgroundColor: theme.palette.primary.main,
  },
  heading: {
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: theme.spacing(1),
  },
  accoridionDetails: {
    display: "inherit",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    padding: 0,
  },
  list: {
    paddingTop: 0,
  },
  p0: {
    paddingLeft: theme.spacing(0),
  },
  avatar: {
    width: 30,
    height: 30,
    marginRight: theme.spacing(2.5),
  },
  name: {
    fontSize: theme.typography.h6.fontSize,
  },
}));

const Accordion = withStyles({
  root: {
    backgroundColor: "transparent",
    boxShadow: "none",
    "&$expanded": {
      margin: "0",
    },
  },
  expanded: {},
})(MuiAccordion);

export default function Statistics() {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [userName, setUserName] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [sumTime, setSumTime] = useState("");
  const [allActivities, setAllActivities] = useRecoilState(allActivitiesState);

  useEffect(() => {
    const fetchAllActivities = async () => {
      if (allActivities.length === 0) {
        const activities = await getAllActivities();
        setAllActivities(activities);
      }
    };
    fetchAllActivities();
  }, [setAllActivities, allActivities.length]);

  useEffect(() => {
    const loadUserInfo = async () => {
      const userInfo = await getCurrentUserInfo();

      if (userInfo) {
        setUserName(userInfo.userName ?? "");
        setPhotoUrl(userInfo.photoUrl ?? "");
        setSumTime(userInfo.sumTime ?? "");

        setIsLoading(false);
      }
    };

    loadUserInfo();
  }, []);

  const longestTrainingDay = calculateLongestActivityDuration(allActivities);
  const stationData = calculateActivityDurationOnStation(allActivities);
  const numberAllExercises = calculateAllExerciseNumbers(allActivities);

  function calculateLongestActivityDuration(allActivitiesFromUser) {
    let durationObj = {
      date: "",
      duration: 0,
    };
    allActivitiesFromUser.forEach((activityDoc) => {
      let exerciseDuration = 0;
      activityDoc.exercises.forEach((exercise) => {
        exerciseDuration += exercise.duration;
      });

      if (exerciseDuration > durationObj.duration) {
        durationObj.date = activityDoc.date;
        durationObj.duration = exerciseDuration;
      }
    });
    return durationObj;
  }

  function calculateActivityDurationOnStation(allActivitiesFromUser) {
    let stations = [];
    allActivitiesFromUser.forEach((activityDoc) => {
      activityDoc.exercises.forEach((exercise) => {
        if (stations.find((station) => station.stNr === exercise.stNr)) {
          stations.forEach((station) => {
            if (station.stNr === exercise.stNr) {
              station.duration += exercise.duration;
              station.numberOfExercisesDone += 1;
            }
          });
        } else {
          stations.push({
            stNr: exercise.stNr,
            stName: exercise.name,
            duration: exercise.duration,
            numberOfExercisesDone: 1,
          });
        }
      });
    });
    return stations;
  }

  function calculateAllExerciseNumbers(allActivitiesFromUser) {
    let exerciseNumber = 0;
    allActivitiesFromUser.forEach((activityDoc) => {
      exerciseNumber += activityDoc.exercises.length;
    });

    return exerciseNumber;
  }

  return (
    <>
      <TitleBar title="Statistiken" navigateTo="/profile" colorPrimary />
      <Wrapper>
        <div className={classes.wrapper}>
          {isLoading ? (
            <Skeleton variant="circle" className={classes.avatar} />
          ) : (
            <Avatar
              className={classes.avatar}
              alt={userName}
              src={photoUrl}
              referrerPolicy="no-referrer"
            />
          )}
          {isLoading ? (
            <Skeleton variant="text" width={210} />
          ) : (
            <Typography className={classes.name} variant="h5">
              {userName}
            </Typography>
          )}
        </div>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<MdExpandMore />}
            style={{ padding: "0" }}
            id="panel1-header"
          >
            <div className={classes.accordionBar}>
              <Avatar className={classes.avatarbg}>
                <MdTimer />
              </Avatar>
              <Typography className={classes.heading}>Trainingsdauer</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.accoridionDetails}>
            <List component="nav" className={classes.list}>
              <ListItem className={classes.p0}>
                <ListItemText primary="Gesamtdauer" />
                <ListItemSecondaryAction>
                  <Typography>{new Date(sumTime * 1000).toISOString().substr(11, 8)}</Typography>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem className={classes.p0}>
                <ListItemText primary="Längster Trainingstag" />
                <ListItemSecondaryAction>
                  <Typography>
                    {new Date(longestTrainingDay.duration * 1000).toISOString().substr(11, 8)}
                  </Typography>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
              <ListSubheader component="div" disableGutters>
                Längste Dauer einer Übung
              </ListSubheader>
              {stationData.map((st, idx) => {
                return (
                  <ListItem className={classes.p0} key={idx}>
                    <ListItemText primary={st.stName} />
                    <ListItemSecondaryAction>
                      <Typography>
                        {new Date(st.duration * 1000).toISOString().substr(14, 5)}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<MdExpandMore />}
            style={{ padding: "0" }}
            id="panel2-header"
          >
            <div className={classes.accordionBar}>
              <Avatar className={classes.avatarbg}>
                <BiRun />
              </Avatar>
              <Typography className={classes.heading}>Übungen</Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.accoridionDetails}>
            <List component="nav">
              <ListItem className={classes.p0}>
                <ListItemText primary="Absolvierte Übungen gesamt" />
                <ListItemSecondaryAction>
                  <Typography>{numberAllExercises}</Typography>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider />
              <ListSubheader component="div" disableGutters>
                Anzahl absolvierter Übung
              </ListSubheader>
              {stationData.map((st, idx) => {
                return (
                  <ListItem className={classes.p0} key={idx}>
                    <ListItemText primary={st.stName} />
                    <ListItemSecondaryAction>
                      <Typography>{st.numberOfExercisesDone}</Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </AccordionDetails>
        </Accordion>
      </Wrapper>
    </>
  );
}
